
const digest = '719073b922c7e8081114314c737afa8801ad360c67887d6cc1d57e6fea693227';
const classes = {"wrapper":"_wrapper_t112h_1","item":"_item_t112h_5"};
const css = `._wrapper_t112h_1 {
  display: flex;
  flex-direction: row;
}
._wrapper_t112h_1 ._item_t112h_5 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  